import { APP_STORE_APP_URL } from '@/constants';

/**
 * Abre a ficha do app na App Store.
 * Em iOS usa a URL HTTPS (redireciona para o app da App Store); nos demais casos abre em nova aba.
 */
export function openAppStoreListing(): void {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return;
  const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
  if (isIos) {
    window.location.assign(APP_STORE_APP_URL);
    return;
  }
  window.open(APP_STORE_APP_URL, '_blank', 'noopener,noreferrer');
}
